import { IVendor, IVendorCompany } from '@/api/types-vendor'

export function updateSameAsFields(vendor: IVendor, item: IVendorCompany): IVendorCompany {
  if (item.sameAsVendorAddress) {
    item.companyEmail = vendor.email
    item.companyName = `${vendor.firstName} ${vendor.lastName}`
    item.companyPhone = vendor.phone
    item.address = vendor.address
    item.city = vendor.city
    item.state = vendor.state
    item.postalCode = vendor.postalCode
  }
  return item
}
